module.exports = __webpack_public_path__ + "static/media/Artsy-earrings-JW-Anderson_thumb.fba3fa7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Artsy-earrings-JW-Anderson_thumb.png
// module id = 234
// module chunks = 0